var amdi18n={"__root":{"cloud_identitites_revokation_successful":"Revokation of Cloud Identities succeeded","message_text_1":"The revokation of your Cloud Identities derived from the selected credential was successful.","message_text_2":"If you wish, you can instantly create a new Cloud Identity <a href=\"javascript:;\">here</a>."},"__de":{"cloud_identitites_revokation_successful":"Sperrung der Cloud Identitäten erfolgreich","message_text_1":"Die Sperrung Ihrer aus dem gewählten Ausweis abgeleiteten Cloud Identitäten war erfolgreich.","message_text_2":"Wenn Sie möchten, können Sie <a href=\"javascript:;\">hier</a> sofort eine neue Cloud Identität erstellen."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/IdentitiesRevokationSucceededState_strings.js
// module id = 347
// module chunks = 2